import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    Banner,
} from '@zillow/constellation';

import appLogger from 'app/shared/loggers/appLogger';

export class ErrorBoundary extends Component {
    state = { hasError: false };

    componentDidCatch(error) {
        this.setState({ hasError: true });

        // You can also log the error to an error reporting service:
        appLogger.logError({
            context: 'ErrorBoundary',
            message: error.message,
        });
    }

    render() {
        const { children, errorView } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return errorView;
        }

        return children;
    }
}

ErrorBoundary.propTypes = {
    errorView: PropTypes.node,
};

ErrorBoundary.defaultProps = {
    errorView: (
        <Banner
            appearance="error"
            body="Oops - something went wrong, please refresh the page and try again!"
            onClose={() => window.location.reload()}
        />
    ),
};

export const withErrorBoundary = WrappedComponent => props => (
    <ErrorBoundary errorView={props.errorView}>
        <WrappedComponent {...props} />
    </ErrorBoundary>
);

export default ErrorBoundary;
